import { createContext, useState } from "react";

export const OrdersManagementContext = createContext();

export const OrdersManagementContextProvider = ({ children }) => {
    const [selectedOrders, setSelectedOrders] = useState([]);

    const contextValue = {
        selectedOrders,
        setSelectedOrders
    };

    return (
        <OrdersManagementContext.Provider value={ contextValue }>
            { children }
        </OrdersManagementContext.Provider>
    );
}
